import { useState, useEffect } from 'react';
import search from "../../assets/images/search.png";
import PaginationTable from "../status/PaginationTable";
import ManageInstitutes from "./ManageInstitutes";
import "./InstituteTables.css";
import AddBank from "./AddBankdetails";
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import axiosInstance from "../../helpers/axios";
import { useSelector, useDispatch } from "react-redux";
import InstituteAutocomplete from '../../components/status/ProjectTable/InstituteSearch';
import { Grid, Button } from '@mui/material';
 

import {
  Card,

} from 'reactstrap';
  
import AddInstitute from "./AddInstitute";
import AddPartner from "./AddPartner";
import GetAllPartners from "./GetAllPartners";
import { useCurrentUser } from '../../hooks/useCurrentUser';
const InstituteTables = () =>{
    const [filterInstituteName, setFilterInstituteName] = useState('');
  const decode = useCurrentUser();
  const user = null;
    const [tableData, setTableData] = useState([]);
    const [currentPage, setcurrentPage] = useState(1);
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [totalFetchRows, setTotalFetchRows] = useState(null);
    const [selectedInstituteBankInfo,setSelectedInstituteBankInfo]=useState(null)
    const [searchText, setSearchText] = useState("")
    const [isLoading, setIsLoading] = useState(true);
    const dispatch = useDispatch();
    const insstate = useSelector((state) => state?.Institutes?.res);
    
    const getinst = `/institute/info?perPage=${rowsPerPage}&pageNo=${currentPage}`;
    const handleAddInstitute = (newInstitute) => {
      setTableData((prevTableData) => [...prevTableData, newInstitute]);
    };

useEffect(()=>{
 
  if(searchText === ""){
    
    const getinst = `/institute/info?perPage=${rowsPerPage}&pageNo=${currentPage}`;

    axiosInstance.get(getinst, {
      headers: {
      },
    })
    .then((res) => {
     
      setTableData(res?.data?.data?.institutes);
      setcurrentPage(res?.data?.data?.pagination?.currentPage);
      setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
      setrowsPerPage(res?.data?.data?.pagination?.perPage);  
      setTimeout(() => {
        setIsLoading(false); 
      }, 300);
    })
    .catch((error) => {
      setIsLoading(false);
      alert(error?.response?.data?.message)
      console.error("Error fetching filtered data:", error);
    });
    }
    
},[])
const [id,setId]=useState(null)
  const getInsituteInfo=(text)=>{
    
    const urlGetInstitute=`/institute/info/name?name=${text}`;
      
    if(text.length>=4)
    {
      axiosInstance.get(urlGetInstitute,{
        headers:{
        }
      }).then((res) => {
        setId(res?.data?.data[0]?.id)
      });
  
   
    }
 
  }
  const handleInputChange = (event) => {

    // if(event.target.value.length >= 4){
      // setSearchText(event.target.value)
    
      const getinst = `/institute/info?instituteId=${id}&perPage=${rowsPerPage}&pageNo=${1}`;
    axiosInstance.get(getinst, {
      headers: {
      },
    })
    .then((res) => {
      setTableData(res?.data?.data?.institutes);
      setcurrentPage(currentPage);
      setTotalFetchRows(res?.data?.data?.pagination.totalRows);
      setrowsPerPage(res?.data?.data?.pagination.perPage);  
   
    })
    .catch((error) => {
      console.error("Error fetching filtered data:", error);
    });
  }
  // else{
  //   setSearchText("")
  //   const getinst = `/institute/info?perPage=${rowsPerPage}&pageNo=${currentPage}`;

  //   axiosInstance.get(getinst, {
  //     headers: {
  //     },
  //   })
  //   .then((res) => {
  //     
  //     setTableData(res?.data?.data?.institutes);
  //     setcurrentPage(res?.data?.data?.pagination.currentPage);
  //     setTotalFetchRows(res?.data?.data?.pagination.totalRows);
  //     setrowsPerPage(res?.data?.data?.pagination.perPage);  
   
  //   })
  //   .catch((error) => {
  //     console.error("Error fetching filtered data:", error);
  //   });



  // }

const paginate = (pageNumber) => {
  // setcurrentPage(pageNumber);
  if(searchText.length >= 4){

    const getinst = `/institute/info?instituteId=${id}&perPage=${rowsPerPage}&pageNo=${currentPage}`;
  axiosInstance.get(getinst, {
    headers: {
    },
  })
  .then((res) => {
    setTableData(res?.data?.data?.institutes);
    setcurrentPage(res?.data?.data?.pagination?.currentPage);
    setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
    setrowsPerPage(res?.data?.data?.pagination?.perPage);  
 
  })
  .catch((error) => {
    console.error("Error fetching filtered data:", error);
  });

  }
  else{
    const getinst = `/institute/info?perPage=${rowsPerPage}&pageNo=${pageNumber}`;
  


  axiosInstance.get(getinst, {
    headers: {
    },
  })
  .then((res) => {
  
    setTableData(res?.data?.data?.institutes);
    setcurrentPage(res?.data?.data?.pagination?.currentPage);
    setTotalFetchRows(res?.data?.data?.pagination?.totalRows);
    setrowsPerPage(res?.data?.data?.pagination?.perPage);  
 
  })
  .catch((error) => {
    console.error("Error fetching filtered data:", error);
  });
  }
  
};


    return(
        <Card style={{width:"100%",backgroundColor:'white',minHeight:'100vh'}}>
          <div>

               <h1 style={{fontFamily:'Inter-Medium',fontSize:'1vw',fontWeight:'500',color:'#D32028',marginTop:'10px',marginLeft:'5px'}}>Institutes</h1>

        
          <Grid container spacing={2} alignItems="center" justifyContent="flex-start" flexWrap="wrap" sx={{marginTop:'20px'}}>
                {/* Merchant Name + Search Results */}
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Box display="flex" gap={3} alignItems="center" >
                    <InstituteAutocomplete
                      onInstituteSelect={(id) => setId(id)}
                      searchIcon={search}
                      handleInputChange={handleInputChange}
                      placeholder={
                        decode?.clientId === '98ffb18a-9fee-43a5-91a3-4b2b9d9ae361'
                          ? 'Product Type'
                          : 'Merchant Name'
                      }
                      customSx={230}
                      marginTop={'3px'}
                      height={'34px'}
                      borderColor={'#CACCCE'}
                    />

                    <Button
                      onClick={() => handleInputChange(id)}
                      sx={{
                        height: '34px',
                        backgroundColor: '#D22129',
                        color: 'white',
                        borderRadius: '5px',
                        fontFamily: 'Inter-Medium',
                        textTransform: 'none',
                        marginBottom:'12px',
                        px: 2,
                        '&:hover': {
                          backgroundColor: '#b81c22',
                        },
                      }}
                    >
                      Search Results
                    </Button>
                  </Box>
                </Grid>
                {(decode?.role === "crm" || decode?.role === "admin")?
                <>
                 <Grid item xs={12} sm={12} md={6} lg={6}>
                  <Box display="flex" gap={3}  justifyContent={'flex-end'}>
                  <GetAllPartners />
                
                  <AddPartner />
                  <AddInstitute onAddInstitute={handleAddInstitute} />
                  </Box>
                </Grid>
                </>:null}
                
             </Grid>
     
 

        {isLoading ? (
           <Box style={{ display: 'flex',alignItems:'center',justifyContent:'center',padding:'15%',backgroundColor:'white',height:'100vh'}}>
           <CircularProgress />
         </Box>
        ):(
          <>
          <div className='tables'  style={{marginTop:'10px'}}>
        <table >
              <thead className='table-heading' style={{width:'100%'}} >
                <tr >
                 
                  <th  style={{  fontSize: '14px',fontFamily:"Inter" ,width:'13em',borderTopLeftRadius:'8px'}} id="insName">
                <span style={{marginLeft:'10px'}}>Brand Name</span> 
                  </th>
                  <th  style={{  fontSize: '14px',fontFamily:"Inter" ,width:'13em'}} id="insName">
                <span style={{marginLeft:'10px'}}>Entity Name</span> 
                  </th>
                  {/* <th  style={{  fontSize: '14px',fontFamily:"Inter" ,width:'13em'}} id="insName">
                <span style={{marginLeft:'10px'}}>Partner Name</span> 
                  </th> */}
                  <th  style={{  fontSize: '14px' ,fontFamily:"Inter",width:'5em',paddingLeft:'10px'}} id="coursename">
                  Inst.code
                  </th>
                  <th   style={{  fontSize: '14px',width:'10em',cursor:'pointer',fontFamily:"Inter" }} id="appfromdate">
                  <span style={{marginLeft:'10px'}}></span>  Email
                  </th>
                  <th   style={{  fontSize: '14px',width:'20em',cursor:'pointer',fontFamily:"Inter" }} id="appfromdate">
                  <span style={{marginLeft:'10px'}}></span>    gstAppl.
                  </th>
                  <th   style={{  fontSize: '14px',width:'20em',cursor:'pointer',fontFamily:"Inter" }} id="appfromdate">
                  <span style={{marginLeft:'10px'}}></span>    gstNumber
                  </th>
                  <th  style={{  fontSize: '14px',fontFamily:"Inter" ,width:'13em'}} id="insName">
                <span style={{marginLeft:'10px'}}>Policy</span> 
                  </th>
                  {(decode?.role === "crm" || decode?.role === "admin") ?  <th   style={{  fontSize: '14px',width:'20em',cursor:'pointer',fontFamily:"Inter",borderTopRightRadius:'8px' }} id="appfromdate">
                  <span style={{marginLeft:'10px'}}></span>   Action
                  </th>:null}
                 
                </tr>
              </thead>
              
              {tableData.map((item,index)=>{
                 const filterInstitute = filterInstituteName.toLowerCase();
                 const currentInstituteName = (item.name || '').toLowerCase();
                 if (currentInstituteName.indexOf(filterInstitute) !== -1)
                return(
                    <tbody className='table-body'>
                    <tr  className='table-row' key={index} style={{ lineHeight: '14px' }}>
                    <td title={item.brandName}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',lineHeight:'1.5em',display:"block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',width:'13em'}}>{item?.brandName?.charAt(0)?.toUpperCase() + item?.brandName?.slice(1)?.toLowerCase()}</span></td>
                    <td title={item.entityName}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',lineHeight:'1.5em',display:"block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',width:'13em'}}>{item?.entityName?.charAt(0)?.toUpperCase() + item?.entityName?.slice(1)?.toLowerCase()}</span></td>
                    <td title={item.code}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',lineHeight:'1.5em',display:"block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',width:'5em'}}>{item.code || '-'}</span></td>
                    <td title={item.email}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',lineHeight:'1.5em',display:"block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',width:'10em'}}>{item.email || '-'}</span></td>
                    <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}>{item.gstApplicable ? 'Yes' : 'No'}</td>
                    <td style={{color:'#667085',fontFamily:'Inter',fontSize:'14px'}}>{item.gstNumber || "-"}</td>
                    <td title={item.notes}><span style={{color:'#667085',fontFamily:'Inter',fontSize:'14px',lineHeight:'1.5em',display:"block",whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',width:'10em',marginLeft:'10px'}}>{item?.notes?item?.notes?.charAt(0)?.toUpperCase() + item?.notes?.slice(1)?.toLowerCase():"-"}</span></td>
                   {(decode?.role === "crm" || decode?.role === "admin") ? <td >
                      <div style={{display:'flex'}}>
                      <span title="Manage Institute" style={{cursor:'pointer' }}>
                        <ManageInstitutes InstituteId={item}/>
                          </span>
                          <span title="Add or edit bank details" style={{  marginLeft:"25px",cursor:'pointer' }}>
                            <AddBank InstituteId={item} />
                          </span>
                      </div>
                    
                    </td>:null}
                    
                    </tr>
                   
                    </tbody>
                )
             
                    })}
              
           
            </table>
        </div>
       
        {totalFetchRows ? ( searchText && totalFetchRows <= 10 ?(
               <div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter", fontSize: '14px',marginLeft:'10px',marginBottom:'5px' }}>
               Showing {totalFetchRows }-{totalFetchRows}{' '}
               records
             </div>
            ):( <div style={{ textAlign: 'center', fontWeight: 'bold',fontFamily:"Inter", fontSize: '14px',marginLeft:'10px',marginBottom:'5px' }}>
            Showing {currentPage * rowsPerPage + 1 - rowsPerPage}-{currentPage * rowsPerPage}{' '}
            records
          </div>)
             
            ) : (
              <div style={{ textAlign: 'center', fontWeight: 'bold', fontFamily:"Inter", fontSize: '14px' }}>No Records</div>
            )}
            <PaginationTable
              startPage={searchText !== "" ? 1 : currentPage}
              rowsPerPage={rowsPerPage}
              totalRows={totalFetchRows}
              paginate={paginate}
              searchText={searchText}
            />
          </>
        )}
        
               </div>
        </Card>
    )
}
export default InstituteTables